module.exports = __webpack_public_path__ + "images/category_lp/retro_game/main-view@2x_49923540464ff5239a50f7e317b3cbd8.png";